export { getDOM } from './get-dom';

export * from './helper';

export * from './node-document';
export * from './node-http';
export * from './node-renderer';
export * from './node-location';
export * from './node-platform';
export * from './node-shared-styles-host';
export * from './tokens';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
